import { createTheme } from '@mui/material/styles';
import { ptBR } from '@mui/material/locale';

export const theme = createTheme({
  palette: {
    primary: { main: '#0267c1' },
    secondary: {
      main: '#263238',
    },
  },
},ptBR);
